export default __webpack_public_path__ + "static/usdc-c4477cfcf6565cacc68bdcdc586a5e9d.png";